import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const GroupIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
    return (
        <MuiIcon {...props}
        >{'\ue7ef'}</MuiIcon>
    );
})
